(() => {
  if (window.jmtBeautyInitialized) return;
  window.jmtBeautyInitialized = true;
  const root = window.Shopify?.routes?.root || '/';
  // The editorial header has its own bag icon, outside Dawn's section replacement.
  // Add responses contain a line item, not a complete cart, so refresh that case.
  let cartRefresh = 0;
  function paintCartCount(cart) {
    if (!Number.isInteger(cart?.item_count)) return;
    document.querySelectorAll('[data-jb-cart-count]').forEach(count => {
      count.textContent = cart.item_count;
      count.closest('a')?.setAttribute('aria-label', 'Shopping bag, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
    });
  }
  async function refreshCartCount(event) {
    const request = ++cartRefresh;
    if (Number.isInteger(event?.cartData?.item_count)) { paintCartCount(event.cartData); return; }
    try {
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (request === cartRefresh) paintCartCount(cart);
    } catch { /* A count failure must never interrupt checkout. */ }
  }
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCartCount(); });
  let lastFocus;
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch { /* Private browsing: still usable. */ } }
  };
  const rememberDismissal = () => {
    storage.set('jmt-glow-dismissed', '1');
    storage.set('jmt-treat-seen', '1');
    document.querySelector('[data-glow-invite]')?.setAttribute('hidden', '');
  };
  const closeDialog = dialog => { if (dialog?.open) dialog.close(); };
  const openDialog = (dialog, trigger) => {
    if (!dialog) return;
    document.querySelectorAll('.jb-nav-dropdown[open]').forEach(el => el.removeAttribute('open'));
    document.querySelectorAll('dialog[open]').forEach(el => { if (el !== dialog) el.close(); });
    lastFocus = trigger || document.activeElement;
    dialog.showModal();
    document.body.classList.add('jb-modal-open');
  };
  document.addEventListener('close', event => {
    if (!event.target.matches('.jb-quiz,.jb-mobile-menu,.jb-welcome')) return;
    if (!document.querySelector('dialog[open]')) {
      document.body.classList.remove('jb-modal-open');
      if (lastFocus?.isConnected && lastFocus.getClientRects().length) lastFocus.focus({ preventScroll: true });
      else document.querySelector('[data-mobile-open]')?.focus({ preventScroll: true });
    }
    if (event.target.matches('.jb-quiz')) rememberDismissal();
    if (event.target.matches('.jb-welcome')) storage.set('jmt-treat-seen', '1');
  }, true);
  document.addEventListener('click', event => {
    const target = event.target;
    const opener = target.closest('[data-glow-open]');
    if (opener) {
      rememberDismissal();
      const quiz = document.querySelector('#JmtGlowQuiz');
      if (['light', 'medium', 'deep'].includes(opener.dataset.startDepth)) {
        quiz?.dispatchEvent(new CustomEvent('jmt:quiz-start', { detail: { depth: opener.dataset.startDepth } }));
      }
      openDialog(quiz, opener);
    }
    if (target.closest('[data-quiz-close]')) closeDialog(document.querySelector('#JmtGlowQuiz'));
    const welcomeOpener = target.closest('[data-welcome-open]');
    if (welcomeOpener) {
      storage.set('jmt-treat-seen', '1');
      openDialog(document.querySelector('#JmtWelcome'), welcomeOpener);
    }
    if (target.closest('[data-welcome-close]')) closeDialog(document.querySelector('#JmtWelcome'));
    if (target.closest('[data-mobile-open]')) openDialog(document.querySelector('#JmtMobileMenu'), target.closest('button'));
    if (target.closest('[data-mobile-close]')) closeDialog(document.querySelector('#JmtMobileMenu'));
    if (target.closest('#JmtMobileMenu a')) closeDialog(document.querySelector('#JmtMobileMenu'));
    if (target.closest('[data-invite-dismiss]')) rememberDismissal();
    if (!target.closest('.jb-nav-dropdown')) document.querySelectorAll('.jb-nav-dropdown[open]').forEach(el => el.removeAttribute('open'));
    if (target.matches('.jb-quiz,.jb-mobile-menu')) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(target);
    }
  });
  document.addEventListener('toggle', event => {
    if (!event.target.matches('.jb-nav-dropdown') || !event.target.open) return;
    document.querySelectorAll('.jb-nav-dropdown[open]').forEach(el => { if (el !== event.target) el.removeAttribute('open'); });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.jb-nav-dropdown[open]').forEach(el => { el.removeAttribute('open'); el.querySelector('summary').focus(); });
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest('.jb-nav-dropdown')) document.querySelectorAll('.jb-nav-dropdown[open]').forEach(el => el.removeAttribute('open'));
  });
  function setupQuiz() {
    const dialog = document.querySelector('#JmtGlowQuiz');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const form = dialog.querySelector('#JmtQuizQuestions');
    const fields = [...form.querySelectorAll('[data-quiz-step]')];
    const result = dialog.querySelector('[data-quiz-result]');
    const progress = dialog.querySelector('[data-quiz-progress]');
    const back = dialog.querySelector('[data-quiz-back]');
    const next = dialog.querySelector('[data-quiz-next]');
    const error = dialog.querySelector('[data-quiz-error]');
    let step = 0;
    function showStep(value, focus = true) {
      step = value;
      form.hidden = false;
      result.hidden = true;
      dialog.querySelector('[data-result-title]').textContent = step === 0 ? 'How tan do you want to go?' : 'Pick your texture.';
      dialog.querySelector('[data-finish-note]').hidden = step !== 0;
      dialog.querySelector('[data-quiz-track]').style.width = step === 0 ? '50%' : '100%';
      fields.forEach((field, index) => { field.hidden = index !== step; });
      progress.textContent = (step + 1) + ' of ' + fields.length;
      back.hidden = step === 0;
      next.querySelector('[data-quiz-next-label]').textContent = step === fields.length - 1 ? 'Show my pick' : 'Next';
      error.hidden = true;
      if (focus && dialog.open) fields[step].querySelector('input').focus({preventScroll:true});
      dialog.scrollTop = 0;
    }
    function showResult() {
      const data = new FormData(form);
      const depth = data.get('depth');
      const format = data.get('format');
      const goalNames = { light: 'Sun-kissed', medium: 'Golden', deep: 'Rich bronze' };
      const products = {
        mist: { title: 'Face & Body Tanning Mist', handle: 'tanning-mist', copy: 'A colorless mist for face and body.', options: 'One formula · Blend with a brush', notes: 'The mist comes in one formula, not separate Light, Medium, or Dark shades. Ask JMT for help with a specific depth.', cta: 'Shop mist' },
        foam: { title: 'Tanning Foam', handle: 'tanning-foam', copy: 'Lightweight color you blend with a mitt.', options: 'Five color bases to choose from', notes: 'Choose from Signature, Violet, Espresso, Bronzer Free, and One Hour Tan bases. Follow the rinse directions for your chosen formula.', cta: 'Shop foam' },
        lotion: { title: 'Self Tanning Lotion', handle: 'tanning-lotion', copy: 'Creamy color with shea butter.', options: 'Light or Dark · Signature or Violet', notes: 'There is no separate Medium shade. For help choosing between Light and Dark, ask JMT. Your starting tone and application affect the result.', cta: 'Shop lotion' },
        serum: { title: 'Tanning Serum', handle: 'tanning-serum', copy: 'Mix it with the moisturizer you love.', options: 'Choose a pump or dropper bottle', notes: 'Mix with moisturizer following the bottle directions. Allow the color to develop before deciding whether to apply more.', cta: 'Shop serum' }
      };
      const match = products[format];
      if (!match || !goalNames[depth]) { showStep(0); return; }
      // Read current Shopify IDs instead of hard-coding them. Never recommend a case
      // pack or silently substitute Light when someone explicitly asks for Deep.
      let catalog;
      try { catalog = JSON.parse(form.querySelector('[data-quiz-product="' + format + '"]').textContent); }
      catch { catalog = { variants: [] }; }
      const variants = (catalog.variants || []).filter(variant => !/case|pack|bulk/i.test(variant.title));
      let selected;
      let productUrl = catalog.url || root + 'products/' + match.handle;
      if (format === 'lotion' && depth !== 'medium') {
        const shade = depth === 'deep' ? 'Dark' : 'Light';
        const matches = variants.filter(variant => variant.options[0]?.startsWith(shade + ' - ') && variant.options[1] === '8 oz');
        selected = matches.find(variant => variant.options[0] === shade + ' - Signature Line') || matches[0];
        match.title = shade + ' Self Tanning Lotion';
        match.cta = 'Shop ' + shade.toLowerCase() + ' lotion';
        match.options = selected ? selected.title.replace(' / ', ' · ') : shade + ' lotion is not currently listed';
        match.notes = 'Your ' + shade.toLowerCase() + ' shade is selected for you. Signature is the starting base; you can switch to Violet on the product page. Your starting tone and application affect the result.';
        if (!selected) {
          productUrl = root + 'pages/contact';
          match.cta = 'Ask about ' + shade.toLowerCase() + ' lotion';
          match.notes = 'We could not find a matching individual ' + shade + ' lotion. Ask JMT for help; we will not substitute another shade or a case pack.';
        }
      } else if (format === 'lotion') {
        match.options = 'No Medium shade · Choose Light or Dark';
        match.notes = 'Lotion comes in Light and Dark, not Medium. Compare the two shades on the product page or ask JMT for help choosing. Your starting tone and application affect the result.';
        match.cta = 'Compare lotion shades';
      } else {
        const defaults = { foam: ['Signature Base', '8 oz'], mist: ['Tanning Mist 4oz'], serum: ['Tanning Serum Pump'] };
        selected = variants.find(variant => defaults[format].every((option, index) => variant.options[index] === option));
        if (selected) match.options = selected.title.replace(' / ', ' · ');
        if (format === 'foam') match.notes = 'Signature Base is preselected, not a Light or Dark shade. You can change the color base on the product page. Follow the rinse directions for your chosen formula; results vary.';
        if (format === 'serum') match.notes = 'The pump is preselected; you can switch to drops on the product page. These are bottle formats, not Light or Dark shades. Mix with moisturizer following the bottle directions.';
      }
      if (selected) {
        productUrl += '?variant=' + encodeURIComponent(selected.id);
        if (!selected.available) {
          match.options += ' · Currently sold out';
          match.cta = 'View ' + (format === 'lotion' && depth !== 'medium' ? (depth === 'deep' ? 'dark' : 'light') + ' lotion' : format);
        }
      }
      dialog.querySelector('[data-result-title]').textContent = match.title;
      dialog.querySelector('[data-result-copy]').textContent = match.copy;
      dialog.querySelector('[data-result-options]').textContent = match.options;
      dialog.querySelector('[data-result-notes]').textContent = match.notes;
      dialog.querySelector('.jb-quiz-notes').open = false;
      dialog.querySelector('[data-result-context]').textContent = 'Your goal: ' + goalNames[depth];
      dialog.querySelector('[data-result-link]').href = productUrl;
      dialog.querySelector('[data-result-link-label]').textContent = match.cta;
      const sourceImage = form.querySelector('[name="format"]:checked').closest('label').querySelector('img');
      const photo = dialog.querySelector('[data-result-photo]');
      photo.replaceChildren();
      if (sourceImage) {
        const image = sourceImage.cloneNode(true);
        image.loading = 'eager';
        image.sizes = '240px';
        photo.append(image);
      }
      form.hidden = true;
      result.hidden = false;
      progress.textContent = 'Your pick';
      dialog.querySelector('[data-result-title]').focus({ preventScroll: true });
      dialog.scrollTop = 0;
      storage.set('jmt-glow-seen', '1');
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!fields[step].querySelector('input:checked')) { error.hidden = false; fields[step].querySelector('input').focus(); return; }
      error.hidden = true;
      if (step < fields.length - 1) showStep(step + 1); else showResult();
    });
    form.addEventListener('change', () => { error.hidden = true; });
    back.addEventListener('click', () => showStep(Math.max(0, step - 1)));
    dialog.querySelector('[data-quiz-restart]').addEventListener('click', () => { form.reset(); showStep(0); });
    dialog.addEventListener('jmt:quiz-start', event => {
      form.reset();
      const radio = [...form.querySelectorAll('[name="depth"]')].find(input => input.value === event.detail.depth);
      if (radio) radio.checked = true;
      showStep(radio ? 1 : 0, false);
    });
  }
  setupQuiz();
  document.addEventListener('shopify:section:load', setupQuiz);
  let welcomeAttempts = 0;
  function welcome() {
    const controller = document.querySelector('[data-glow-controller]');
    if (!controller || controller.dataset.autoInvite !== 'true' || window.Shopify?.designMode) return;
    if (!document.body.classList.contains('template-index')) return;
    if (storage.get('jmt-treat-seen') || location.hash) return;
    // Never interrupt someone already typing, using a menu, or choosing a product.
    // A busy or background tab should defer the invitation, not silently lose it.
    if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select') || document.querySelector('.jb-nav-dropdown[open], [data-quick-buy][open]')) {
      if (++welcomeAttempts < 60) setTimeout(welcome, 1000);
      return;
    }
    const dialog = document.querySelector('#JmtWelcome');
    if (!dialog) return;
    storage.set('jmt-treat-seen', '1');
    openDialog(dialog);
  }
  setTimeout(welcome, 4000);
  const welcomeDialog = document.querySelector('#JmtWelcome');
  const welcomeForm = welcomeDialog?.querySelector('form');
  if (welcomeDialog?.querySelector('[data-welcome-response]') && location.hash === '#' + welcomeForm?.id) {
    storage.set('jmt-treat-seen', '1');
    openDialog(welcomeDialog);
  }
  window.matchMedia('(min-width: 990px)').addEventListener('change', event => { if (event.matches) closeDialog(document.querySelector('#JmtMobileMenu')); });
})();
